/** @jsx jsx */
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
  PAGES__SHAPE_ITEM,
  RESULT__ITEM_SHAPE,
  SURVEY_CLIENT__SHAPE_ITEM,
} from '../../../redux/constants';
import { redirecterCss } from './redirecter-page.css';
import { contentCss } from '../content-page/content-page.css';
import { Elements } from '../../elements';
import { NoElementsWarning } from './no-elements-warning';
import { selectActiveRequestsCount } from '../../../redux/api-client/selectors.api-client';

export function RedirecterPage(props) {
  const { redirect, page, result, surveyClient } = props;
  const { state } = result || {};
  const { token } = surveyClient || {};
  const requestCount = useSelector(selectActiveRequestsCount);

  const redirectLink = page.redirectLinkWithUtms || page.redirectLink;

  const shouldRedirect =
    token && redirectLink && state === 'started' && requestCount === 0 && page.impressionCreated;

  useEffect(() => {
    if (shouldRedirect) {
      redirect(token, redirectLink);
    }
  }, [shouldRedirect]);

  return (
    <div css={redirecterCss}>
      <div css={contentCss}>
        <Elements {...props} styles={props.page.css} omitHidden parentId={props.page.id} />
        <NoElementsWarning {...props} parentId={props.page.id} />
      </div>
    </div>
  );
}

RedirecterPage.propTypes = {
  redirect: PropTypes.func,
  page: PAGES__SHAPE_ITEM.isRequired,
  result: RESULT__ITEM_SHAPE,
  surveyClient: SURVEY_CLIENT__SHAPE_ITEM,
};

RedirecterPage.defaultProps = {
  redirect: () => {},
  result: undefined,
  surveyClient: undefined,
};
